import React, { useState } from "react";
import LoadSimple from "../../LoadSimple";

const TablePortafolioDevices = ({
  buscar_cis_history,
  searchResults,
  searchTerm,
  server,
  dataCisConf,
}) => {
  const [deleteCisModalOpen, setdeleteCisModalOpen] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [registerIsValid, setRegisterIsValid] = useState(false);
  const [cisConfSelected, setCisConfSelected] = useState({});
  const [deleteBuzonModalOpen, setdeleteBuzonModalOpen] = useState(false);
  const [userSelected, setUserSelected] = useState({});
  function openDeleteUserModalauth() {
    setdeleteBuzonModalOpen(true);
  }

  function closDeleteBuzonModal() {
    setdeleteBuzonModalOpen(false);
  }
  const handleActionResponse = (data) => {
    setUserSelected(data);
    openDeleteUserModalauth();
    // Realiza las acciones deseadas al hacer clic en el marcador
  };
  var dataList = searchTerm === "" ? dataCisConf.data.data : searchResults;

  const handledeleteUserClick = (data) => {
    setCisConfSelected(data);
    openDeleteUserModal();
  };
  function openDeleteUserModal() {
    setdeleteCisModalOpen(true);
  }

  function closDeleteCisModal() {
    setdeleteCisModalOpen(false);
    buscar_cis_history();
  }
  const handleChangReqAuth = (element) => {
    if (element.status == "No iniciado") {
      // requests_auth(element)
      handleActionResponse(element);
    } else {
      cancel_auth(element);
    }
  };
  function requests_auth(element, txtarea) {
    const data = {
      process_id: 1,
      comments: txtarea,
    };
    setLoading(true);
    setRegisterIsValid(true);
    const fetchDataPost = async () => {
      let url =
       server.url +
        "/api/v1/cassia/ci_elements/history/authorization/create/" +
        element.conf_id;
      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify(data),
        });
        if (response.ok) {
          const data1 = await response.json();
          setLoading(false);
          setRegisterIsValid(false);
          // Manejo de la respuesta
          setData(data1);
          closDeleteCisModal();
          // console.log(data1);
        } else {
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        // Manejo de errores
        setError(error);
        console.error(error);
      }
    };

    fetchDataPost();
  }
  function cancel_auth(element) {
    const data = {
      process_id: 1,
      comments: "comentario de prueba",
    };
    setLoading(true);
    setRegisterIsValid(true);
    const fetchDataPost = async () => {
      let url =
       server.url +
        "/api/v1/cassia/ci_elements/history/authorization/cancel/" +
        element.conf_id;
      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });
        if (response.ok) {
          const data1 = await response.json();
          setLoading(false);
          setRegisterIsValid(false);
          // Manejo de la respuesta
          setData(data1);
          closDeleteCisModal();
          // console.log(data1);
        } else {
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        // Manejo de errores
        setError(error);
        console.error(error);
      }
    };

    fetchDataPost();
  }
  return (
    <div className="cont-table-mantenimiento-config">
      <div className="head-table-mantenimiento-config">
        <div className="field-head-table-mantenimiento-config field-small">
          Id de elemento
        </div>
        <div className="field-head-table-mantenimiento-config field-small">Host ID</div>
        <div className="field-head-table-mantenimiento-config field-medium">IP</div>
        <div className="field-head-table-mantenimiento-config field-larger">Nombre</div>
        <div className="field-head-table-mantenimiento-config field-medium">
          Descripcion
        </div>
        <div className="field-head-table-mantenimiento-config field-medium">
          Marca de Hardware
        </div>
        <div className="field-head-table-mantenimiento-config field-medium">
          Modelo de Hardware
        </div>
        <div className="field-head-table-mantenimiento-config field-medium">
          Version de Software
        </div>
        {/* <div className='field-head-table-mantenimiento-config field-medium'>
                                            CI´s afecta
                                        </div>
                                        <div className='field-head-table-mantenimiento-config field-medium'>
                                            Documentos
                                        </div> */}
      </div>
      <div className="body-table-mantenimiento-config">
        <>
          <div className="cont-row-user-list">
            {dataCisConf.loading ? (
              <div className="cont-load-user-list">
                <LoadSimple></LoadSimple>
              </div>
            ) : (
              // console.log(elemento)
              //    (dataCisConf.data.length>0)?
              // dataCisConf.data.data.history.map((elemento, indice) => (
              (dataList.map((elemento, indice) => (
                <div className="row-table-mantenimiento" key={indice}>
                  <div className="field-body-table-mantenimiento field-small">
                    {elemento.element_id}
                  </div>
                  <div className="field-body-table-mantenimiento field-small">
                    {elemento.host_id}
                  </div>
                  <div className="field-body-table-mantenimiento field-medium">
                    {elemento.ip}
                  </div>
                  <div className="field-body-table-mantenimiento field-larger">
                    {elemento.name}
                  </div>
                  <div className="field-body-table-mantenimiento field-medium">
                    {elemento.description}
                  </div>
                  <div className="field-body-table-mantenimiento field-medium">
                    {elemento.hardware_brand}
                  </div>
                  <div className="field-body-table-mantenimiento field-medium">
                    {elemento.hardware_model}
                  </div>
                  <div className="field-body-table-mantenimiento field-medium">
                    {elemento.software_version}
                  </div>
                </div>
              )))
            )}
            {
              //   (dataList.length==0)?<div className="no-results">SIN RESULTADOS.</div>:''
            }
          </div>
        </>
      </div>
    </div>
  );
};

export default TablePortafolioDevices;
